export class UserLoginRequest {
  email: string;
  senha: string;
}
